import { generateLineItemId } from '../../api/implementations/utils';

const pageInstanceId = generateLineItemId();

export const getPageInstanceId = () => pageInstanceId;
